import {Modal,Form,Upload,message} from "antd"
import { useState } from "react";

const {Item}=Form
export default function ModalEditData(props) {
    const {data,options}=props;
    const {open,onCancel,onUpdateLogo}=options
    const [form]=Form.useForm()
    const [imageLogo,setImageLogo]=useState({
      previewVisible: false,
      previewImage: "",
      previewTitle: "",
      fileList: [],
      file:"",
   })
   

    const handleChange=({ file, fileList })=>{
      const isImage=file.type==="image/png" || file.type==="image/jpg" || file.type==="image/jpeg" 
         if(!isImage){
            message.error("El tipo de image no es valida");
         }
         const isImageTam= file.size <= 1000000
          if(!isImageTam){
            message.error("La imagen excede los 1MB");
         }
         if (isImageTam && isImage) {
            
            setImageLogo({...imageLogo,file,fileList})
         } else {
            fileList.pop()
            file=""
            setImageLogo({...imageLogo,file,fileList})
         }
    }
    const handleCancel=()=>{
      onCancel(false)
      setImageLogo({
         ...imageLogo,
         fileList: []
      })
    }
    const bUpload = (file) => {
      return false;
    };

    const onFinish=()=>{
      onUpdateLogo(imageLogo.fileList)
      onCancel(false)
    }
    
     return(
        <>
        <Modal
        open={open}
        onCancel={handleCancel}
        onOk={()=>{form.submit()}}
        >
         <Form
         fields={data}
         form={form}
         onFinish={onFinish}
         >
            <Item
            name={data?.name}
            >
               <Upload
               name={"picture"}
               listType="picture-card"
               beforeUpload={bUpload}
               onChange={handleChange}
               fileList={imageLogo.fileList}
               maxCount={1}
               >
                  {
                  imageLogo.fileList.length >= 1 ?   
                  ("Cambiar logo"):
                  ("Subir el logo")
                 }
               </Upload>
            </Item>
         </Form>
        </Modal>  
        </>
     )   
}